import { useEffect, useState } from "react"
import { getProyectos } from '../componentes/api.js';
import Modal from '../comun/VentanaModal.jsx'
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';


const Historico =()=>{
  const [proyectos, setProyectos] = useState([]);
  const [cant, setCant] = useState(0);
   /** Para el manejo de la ventana de mensajes modal**/
   const [show, setShow] = useState(false);
   const [msg, setMsg] = useState([]);
   const handleClose = () => setShow(false);


  
  useEffect(() =>{
    cargarProyectos();

  },[]);


  const cargarProyectos = async()=>{
    try {
      const response = await getProyectos()
      setProyectos(response.data)
      setCant(response.data.length)
            
    } catch (error) {
      mostrarMsg(["ERROR", "Ocurrio un error al cargar los Proyectos", error])
    }
  }

  
  const mostrarMsg = (msg)=>{
    setMsg(msg)
    setShow(true)
  }

  return(
   <div className="container-fluid mt-2">
      <div className="row card">
        <Alert severity="success">
          <AlertTitle><strong>HISTORICO DE PROYECTOS - Cantidad: {cant}</strong></AlertTitle>
          Los siguientes son los proyectos que se encuentran registrados en la base de datos
        </Alert>
    
        <div className="row mt-2">
          <table className="table table-hover table-bordered">
            <thead className="table-primary">
              <tr>
                <th scope="col"># Item</th>
                <th scope="col"># ID</th>
                <th scope="col">Nombre</th>
                <th scope="col">Fecha de Inicio</th>
                <th scope="col">Fecha Final</th>
                <th scope="col">Avance</th>
                <th scope="col">Estado</th>
              </tr>
            </thead>
            <tbody>
              {proyectos.map((reg, i)=>{
                return(
                <tr  className={reg.Activo==='Inactivo'? "table-danger":""} key={i}>
                  <th> {i + 1} </th>
                  <th> {reg.Id} </th>
                  <th> {reg.Nbre} </th>
                  <th> {reg.FechaIni.substring(0,10)} </th>
                  <th> {reg.FechaFin.substring(0,10)} </th>
                  <th> {reg.Estado} </th>
                  <th> {reg.Activo} </th>
                </tr>
                )
              })}
              
            </tbody>
          </table>
        </div>
      </div>
      <Modal show={show} handleClose={handleClose} msg={msg} />
    </div>
  )
}

export default Historico